
import {
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router';

import Container from './components/Feature/ClaimQuestionTree/Container.vue';
import PersonalInformation from './components/Feature/CreateMember/views/PersonalInformation.vue';
import MemberEligibility from './components/Feature/CreateMember/views/MemberEligibility.vue';
import EligibilityResult from './components/Feature/CreateMember/views/EligibilityResult.vue';

import Bike from './components/Feature/BikeTheftClaimFlow/views/Bike.vue';
import Confirmation from './components/Feature/BikeTheftClaimFlow/views/Confirmation.vue';
import ExtraEquipment from './components/Feature/BikeTheftClaimFlow/views/ExtraEquipment.vue';
import SplashPage from './components/Feature/BikeTheftClaimFlow/views/SplashPage.vue';
import Summary from './components/Feature/BikeTheftClaimFlow/views/Summary.vue';
import WhatHappened from './components/Feature/BikeTheftClaimFlow/views/WhatHappened.vue';

const routes = {
  '/skade': [
    {
      name: 'root',
      path: '/',
      component: Container,
      props: true
    },
    {
      name: 'level1',
      path: '/:level1',
      component: Container,
      props: true
    },
    {
      name: 'level2',
      path: '/:level1/:level2',
      component: Container,
      props: true
    },
    {
      name: 'level3',
      path: '/:level1/:level2/:level3',
      component: Container,
      props: true
    },
    {
      name: 'level4',
      path: '/:level1/:level2/:level3/:level4',
      component: Container,
      props: true
    },
    {
      name: 'level5',
      path: '/:level1/:level2/:level3/:level4/:level5',
      component: Container,
      props: true
    },
    {
      name: 'level6',
      path: '/:level1/:level2/:level3/:level4/:level5/:level6',
      component: Container,
      props: true
    },
    {
      name: 'level7',
      path: '/:level1/:level2/:level3/:level4/:level5/:level6/:level7',
      component: Container,
      props: true
    },
    {
      name: 'level8',
      path: '/:level1/:level2/:level3/:level4/:level5/:level6/:level7/:level8',
      component: Container,
      props: true
    }
  ],
  '/beregn-pris/personlige-oplysninger': [
    {
      name: 'personal-information',
      path: '/',
      component: PersonalInformation
    },
    {
      name: 'member-eligibility',
      path: '/kan-jeg-blive-medlem',
      component: MemberEligibility
    },
    {
      name: 'eligibility-result',
      path: '/medlem-resultat',
      component: EligibilityResult
    }
  ],
  '/opret-cykel-skade': [
    {
      name: 'root',
      path: '/opret-cykel-skade',
      component: SplashPage
    },
    {
      name: 'what',
      path: '/opret-cykel-skade/what',
      component: WhatHappened
    },
    {
      name: 'bike',
      path: '/opret-cykel-skade/what/bike',
      component: Bike
    },
    {
      name: 'equipment',
      path: '/opret-cykel-skade/what/bike/equipment',
      component: ExtraEquipment
    },
    {
      name: 'summary',
      path: '/opret-cykel-skade/what/bike/equipment/summary',
      component: Summary
    },
    {
      name: 'summary-without-equipment',
      path: '/opret-cykel-skade/what/bike/summary',
      component: Summary
    },
    {
      name: 'confirmation',
      path: '/opret-cykel-skade/what/bike/summary/confirmation',
      component: Confirmation
    }
  ]
};

routes['/beregn pris/personlige oplysninger'] = routes['/beregn-pris/personlige-oplysninger'];

export function afterEach() {
  // Util.scrollToTop();
}

function createPortalRouter(path) {
  const pathName = decodeURI(path).toLowerCase();

  if (pathName in routes) {
    let r = routes[pathName];

    const router = createRouter({
      routes: r,
      history: pathName === '/opret-cykel-skade' ? createWebHistory() : createWebHashHistory()
    });  
    router.afterEach(() => afterEach());
    return router;
  }
  return null;
}

export {createPortalRouter, routes};